import React from 'react';
import {FmlxProgressBar} from 'fmlx-common-ui';
import {FMLX_PROGRESS_BAR} from '../../const/FmlxComponentEnum';
import './Loading.scss';

const Loading = () => {
  return (
    <div className='loading-component'>
      <FmlxProgressBar
        variant={FMLX_PROGRESS_BAR.VARIANT.INDETERMINATE}
      />
    </div>
  );
};

Loading.propTypes = {};

Loading.defaultProps = {};

export default Loading;
